import { MISSION_VISION } from "../../data/siteData";
import "./MissionVision.css";

function MissionVision() {
  return (
    <section className="mission-vision">
      <div className="container mission-vision__grid">
        {MISSION_VISION.map((item) => (
          <div className="mission-vision__card" key={item.number}>
            <span className="mission-vision__number">{item.number}</span>
            <h3 className="mission-vision__title">{item.title}</h3>
            <p className="mission-vision__text">{item.text}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

export default MissionVision;